import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";
import { hydrateSession } from "@/lib/api";

// Production builds must not leak diagnostic output (code-review requirement).
if (process.env.NODE_ENV === "production") {
  console.debug = () => {};
  console.log = () => {};
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// Decrypt the stored session (IndexedDB, AES-GCM) before the first render so
// route guards see the signed-in user synchronously.
hydrateSession().finally(() => {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
});

registerServiceWorker();
